import { createAction } from 'redux-actions';

export const setUser = createAction('SET_USER');
export const setRoles = createAction('SET_ROLES');
export const setActiveVenueId = createAction('SET_ACTIVE_VENUE_ID');